export default "__VITE_ASSET__C2PVUP7b__"